// Checks if the scrollbar is visible returns true if it is
const isScrollbarVisible = (
    element: HTMLElement = document.documentElement,
): boolean => {
    return element.scrollHeight > element.clientHeight;
};

export default isScrollbarVisible;
